import { Shield, Leaf, Heart, HandHeart } from "lucide-react";

export const LifeCoverage = () => {
  return (
    <section className="py-12 px-4 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <div className="bg-white p-8 rounded-lg shadow-sm animate-scale-in" style={{ animationDelay: "0.2s" }}>
            <h2 className="text-2xl font-semibold text-primary-dark mb-4">
              Policy Types
            </h2>
            <ul className="space-y-4">
              <li className="flex items-start">
                <Shield className="h-6 w-6 text-primary mr-2 flex-shrink-0" />
                <div>
                  <h3 className="font-medium">Term Life Insurance</h3>
                  <p className="text-neutral">Affordable coverage for a specific period of time.</p>
                </div>
              </li>
              <li className="flex items-start">
                <Leaf className="h-6 w-6 text-primary mr-2 flex-shrink-0" />
                <div>
                  <h3 className="font-medium">Whole Life Insurance</h3>
                  <p className="text-neutral">Lifetime coverage with cash value accumulation.</p>
                </div>
              </li>
              <li className="flex items-start">
                <Heart className="h-6 w-6 text-primary mr-2 flex-shrink-0" />
                <div>
                  <h3 className="font-medium">Universal Life Insurance</h3>
                  <p className="text-neutral">Flexible coverage and investment options.</p>
                </div>
              </li>
            </ul>
          </div>

          <div className="bg-white p-8 rounded-lg shadow-sm animate-scale-in" style={{ animationDelay: "0.4s" }}>
            <h2 className="text-2xl font-semibold text-primary-dark mb-4">
              Benefits
            </h2>
            <ul className="space-y-4">
              <li className="flex items-start">
                <HandHeart className="h-6 w-6 text-primary mr-2 flex-shrink-0" />
                <div>
                  <h3 className="font-medium">Financial Security</h3>
                  <p className="text-neutral">Provide for your family's future needs.</p>
                </div>
              </li>
              <li className="flex items-start">
                <Shield className="h-6 w-6 text-primary mr-2 flex-shrink-0" />
                <div>
                  <h3 className="font-medium">Debt Protection</h3>
                  <p className="text-neutral">Cover outstanding debts and final expenses.</p>
                </div>
              </li>
              <li className="flex items-start">
                <Leaf className="h-6 w-6 text-primary mr-2 flex-shrink-0" />
                <div>
                  <h3 className="font-medium">Legacy Planning</h3>
                  <p className="text-neutral">Create a lasting financial legacy for your loved ones.</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};